/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';

import {  
  Card,  
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
let goal = {}; 
let session;
let se;

const GoalSettingedit = (e) => {    
  
  const history = useHistory();

  if(session === null){    
    window.location = '/';
  }
    
  const preparationPage = (e) => {    
    history.push('../parent/son');
  }
  
///////////////////

  const [edit_date, setEditdate] = useState();
  const [technical1, setTechnical1] = useState();
  const [technical2, setTechnical2] = useState();
  const [technical3, setTechnical3] = useState();
  const [technical4, setTechnical4] = useState();
  const [tactics1, setTactics1] = useState();
  const [tactics2, setTactics2] = useState();
  const [tactics3, setTactics3] = useState();
  const [tactics4, setTactics4] = useState();
  const [body1, setBody1] = useState();
  const [body2, setBody2] = useState();
  const [body3, setBody3] = useState();
  const [body4, setBody4] = useState();
  const [mental1, setMental1] = useState();
  const [mental2, setMental2] = useState();
  const [mental3, setMental3] = useState();
  const [mental4, setMental4] = useState();
  const [match1, setMatch1] = useState();
  const [match2, setMatch2] = useState();
  const [match3, setMatch3] = useState();
  const [match4, setMatch4] = useState();
  const [responsee, setResponsee] = useState();
  const [hindrance, setHindrance] = useState();

  useEffect(() => {
    
    session = window.sessionStorage.getItem('player'); 
    
    if(window.sessionStorage.getItem('goal') !== null ){

      goal = window.sessionStorage.getItem('goal'); 
      goal = JSON.parse(goal); 

      setEditdate(goal['edit_date']);

      setTechnical1(goal['technical1']);
      setTechnical2(goal['technical2']);
      setTechnical3(goal['technical3']);
      setTechnical4(goal['technical4']);

      setTactics1(goal['tactics1']);
      setTactics2(goal['tactics2']);
      setTactics3(goal['tactics3']);
      setTactics4(goal['tactics4']);

      setBody1(goal['body1']);
      setBody2(goal['body2']);
      setBody3(goal['body3']);
      setBody4(goal['body4']);

      setMental1(goal['mental1']);
      setMental2(goal['mental2']);
      setMental3(goal['mental3']);
      setMental4(goal['mental4']);

      setMatch1(goal['match1']);
      setMatch2(goal['match2']);
      setMatch3(goal['match3']);
      setMatch4(goal['match4']);

      setHindrance(goal['hindrance']);
      setResponsee(goal['responsee']);

    }else{
      
    }

    se = JSON.parse(session);

    goal['user_id'] = se["id"];
  }, []);
  return (

    <>
      <div className="content coach-user-content px-0 pb-0">
        <Row className="mx-0 px-0">          
          <Col md="12" className="px-0">
            <Card className="card-user mb-0">              
              <CardBody>
                <Form>                  
                  <Row>                    
                    <Col className="px-1">
                      <FormGroup>
                        <label><h6>私は、次の３ヶ月間の目標に向かってベストを尽くします。</h6></label>                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>  
                    <Col className="px-1">
                      <FormGroup>
                        <label>記入日</label>
                        <Input type="date" readOnly="readonly" style={{background:'white'}} id="edit_date" value={edit_date == null ? '' : edit_date}  step="1"/>
                      </FormGroup>
                    </Col>                                      
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <label>テクニカルな目標</label>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="technical1" value={technical1 == null ? '' : technical1}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}}id="technical2" value={technical2 == null ? '' : technical2}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="technical3" value={technical3 == null ? '' : technical3}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="technical4" value={technical4 == null ? '' : technical4}/>
                      </FormGroup>
                    </Col>
                  </Row>  

                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <label>戦術の目標</label>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="tactics1" value={tactics1 == null ? '' : tactics1}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="tactics2" value={tactics2 == null ? '' : tactics2}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="tactics3" value={tactics3 == null ? '' : tactics3}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="tactics4" value={tactics4 == null ? '' : tactics4}/>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <label>身体面の目標</label>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="body1" value={body1 == null ? '' : body1}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="body2" value={body2 == null ? '' : body2}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="body3" value={body3 == null ? '' : body3}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="body4" value={body4 == null ? '' : body4}/>
                      </FormGroup>
                    </Col>
                  </Row> 

                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <label>メンタルの目標  </label>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="mental1" value={mental1 == null ? '' : mental1}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="mental2" value={mental2 == null ? '' : mental2}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="mental3" value={mental3 == null ? '' : mental3}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="mental4" value={mental4 == null ? '' : mental4}/>
                      </FormGroup>
                    </Col>
                  </Row> 
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <label>以上の私の目標の障害になる事 </label>                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{textAlign: 'center'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="hindrance" value={hindrance == null ? '' : hindrance} placeholder="例 : スマホをいじってしまう"/>
                        {/*<label>スマホをいじってしまう  </label>*/}
                      </FormGroup>
                    </Col>
                  </Row> 

                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{marginBottom:'3px'}}>
                        <label>それらについて私は次のように打ち勝つように努力します。</label>                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <FormGroup style={{textAlign: 'center'}}>
                        <Input type="text" readOnly="readonly" style={{background:'white'}} id="responsee" value={responsee == null ? '' : responsee} placeholder="例 : 時間を決めてスマホを使う"/>
                        {/*<label>時間を決めてスマホを使う  </label>*/}
                      </FormGroup>
                    </Col>
                  </Row> 
                  <Row>
                    <Col className="px-1">
                      <input type="button" name="user" value="戻る" className="btn-round btn btn-primary" onClick={preparationPage}/>
                    </Col>                                  
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default GoalSettingedit;
